module.exports = __webpack_public_path__ + "static/img/img-educator-feature-1@2x.f3a64de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-1@2x.png
// module id = V3ww
// module chunks = 18